import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import GlassCard from '../../../shared/components/card/GlassCard';
import LoginForm from '../components/LoginForm';
import '../../../styles/LoginForm.css';
import FormChangePassProcess from '../components/FormChangePassProcess';

const LoginPage = ({type = true}) => {
  const { login } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ identifier: '', password: '' });
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.identifier || !formData.password) return;

    setIsLoading(true);
    setError('');
    setShake(false);
    try {
      await login(formData); // llamada real al contexto
      // Si el login es exitoso, el contexto actualizará el estado global
      // y App automáticamente redirigirá a la siguiente pantalla
    } catch (err) {
      setError(getErrorMessage(err));
      setShake(true);
      setTimeout(() => setShake(false), 2000);
    } finally {
      setIsLoading(false);
    }
  };

  // Función para mapear errores específicos
  const getErrorMessage = (err) => {
    // Si tu API devuelve un código o mensaje específico
    const statusCode = err?.response?.status;
    const serverMessage = err?.response?.data?.message;
    const errorCode = err?.code;

    // Error específico del servidor
    if (serverMessage) return serverMessage;

    // Errores por código de estado HTTP
    switch (statusCode) {
      case 400:
        return 'Datos incompletos. Verifica usuario y contraseña.';
      case 401:
        return 'Usuario o contraseña incorrectos.';
      case 403:
        return 'Cuenta bloqueada o sin permisos.';
      case 404:
        return 'Usuario no encontrado.';
      case 429:
        return 'Demasiados intentos. Espera unos minutos.';
      case 500:
        return 'Error del servidor. Intenta más tarde.';
      case 503:
        return 'Servicio no disponible. Mantenimiento en curso.';
      default:
        break;
    }

    // Errores de red/conexión
    switch (errorCode) {
      case 'ECONNABORTED':
      case 'TIMEOUT':
        return 'Tiempo de espera agotado. Revisa tu conexión.';
      case 'NETWORK_ERROR':
      case 'ERR_NETWORK':
        return 'Sin conexión a internet.';
      case 'ECONNREFUSED':
        return 'No se pudo conectar con el servidor.';
      default:
        break;
    }

    // Mensaje genérico si no coincide nada
    return 'Error al iniciar sesión. Intenta de nuevo.';
  };

  return (
    <div className="minimal-container">
      <div className='center-container'>

      </div>
      <GlassCard>
        <>
          {type? 
            (
              <LoginForm
                formData={formData}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                error={error}        // ← Pasar error
                shake={shake}
              />
            )
            :
            (
              <FormChangePassProcess/>
            )
          }
        </>
      </GlassCard>
    </div>
  );
};

export default LoginPage;